import V1 from '@/system-modules/win-manager/v1/WinManagerV1'
import SystemModuleConfig from '@/contracts/system/configs/SystemModuleConfig'
import { ISysWinManagerModule } from '@/contracts/system-modules/win-manager/ISysWinManagerModule'
import { Provider } from '@/contracts/core/provider/entity/Provider'

const version = SystemModuleConfig.getWinManagerVersion()

export class WinManagerProvider extends Provider<ISysWinManagerModule> {
  realizations: Record<string, ISysWinManagerModule> = {
    v1: V1(),
  }
}

const instance: { module: ISysWinManagerModule | null } = { module: null }

export function SysWinManagerProviderModule(): ISysWinManagerModule {
  if(!instance.module){
    instance.module = new WinManagerProvider().module(version)
  }

  return instance.module
}
